export const de = {
	"navigation.users": "Nutzer",

	"title": "Produkte von {{brand}}",

	"models.title": "Modelle",
	"lenses.title": "Linsenglas",
	"plasticcolors.title": "Farben",

	"model.subtitle": "von {{brand}}",

	"tryon": "Try On",

	"duplicate": "Duplizieren",
	"edit": "Bearbeiten",
	"delete": "Löschen",
	"cancel": "Abbrechen",
	"submit": "Abspeichern"
};